import React, { Component, Fragment } from "react";
import {
  Row,
  Col,
  Label,
  Input,
  Button,
  InputGroup,
  InputGroupAddon,
  FormGroup,
} from "reactstrap";
import DatePicker from "react-datepicker";
import lodash from "lodash";
import { Typeahead } from "react-bootstrap-typeahead";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faSearch,
  faCalendarAlt,
} from "@fortawesome/free-solid-svg-icons";
import CustomSpinner from "../CustomSpinner/CustomSpinner";

import Validation from "../../services/Validation";
import SalesReportService from "../../services/SalesReportService";
import ModalService from "../../services/ModalService";
import "./AddEditActivity.css";
import swal from "sweetalert";
import ActivityReportService from "../../services/ActivityReportService";
import TextareaAutosize from "react-autosize-textarea/lib";
import NewFleetService from "../../services/NewFleetService";

class AddEditActivity extends Component {
  constructor(props) {
    super(props);
    this.state = {
      customerData: [],
      tbbSkuData: [],
      tbrSkuData: [],
      brandData: [],
      frontBrandPattern: [],
      rearBrandPattern: [],
      salesData: {},
      controls: {
        activity_type: {
          value: "",
          valid: null,
          touched: false,
          message: null,
          nullValue: null,
        },
        tyreQuantity: {
          value: "",
          valid: null,
          touched: false,
          message: null,
          nullValue: null,
        },
        fleet_id: {
          value: {},
          valid: null,
          touched: false,
          message: null,
          nullValue: null,
        },
        activity_date: {
          value: null,
          valid: null,
          touched: false,
          message: null,
          nullValue: null,
        },
        number_of_vehicles_inspected: {
          value: "",
          valid: null,
          touched: false,
          message: null,
          nullValue: null,
        },
        number_of_wheels_inspected: {
          value: "",
          valid: null,
          touched: false,
          message: null,
          nullValue: null,
        },
        average_inflation_pressure_noted: {
          value: "",
          valid: null,
          touched: false,
          message: null,
          nullValue: null,
        },
        select_alignment_practices: {
          value: "good",
          valid: null,
          touched: false,
          message: null,
          nullValue: null,
        },
        select_rotation_practices: {
          value: "good",
          valid: null,
          touched: false,
          message: null,
          nullValue: null,
        },
        front_axel_brand: {
          value: "",
          valid: null,
          touched: false,
          message: null,
          nullValue: null,
        },
        front_axel_pattern: {
          value: "",
          valid: null,
          touched: false,
          message: null,
          nullValue: null,
        },
        rear_axel_brand: {
          value: "",
          valid: null,
          touched: false,
          message: null,
          nullValue: null,
        },
        rear_axel_pattern: {
          value: "",
          valid: null,
          touched: false,
          message: null,
          nullValue: null,
        },
        major_observation: {
          value: "",
          valid: null,
          touched: false,
          message: null,
          nullValue: null,
        },
        image_1: {
          value: "",
          valid: null,
          touched: false,
          message: null,
          nullValue: null,
        },
        image_2: {
          value: "",
          valid: null,
          touched: false,
          message: null,
          nullValue: null,
        },
        image_3: {
          value: "",
          valid: null,
          touched: false,
          message: null,
          nullValue: null,
        },
        number_of_driver_attended: {
          value: "",
          valid: null,
          touched: false,
          message: null,
          nullValue: null,
        },
        major_issue_before_dtp: {
          value: "",
          valid: null,
          touched: false,
          message: null,
          nullValue: null,
        },
        solution_given: {
          value: "",
          valid: null,
          touched: false,
          message: null,
          nullValue: null,
        },
        feedback_by_drivers: {
          value: "",
          valid: null,
          touched: false,
          message: null,
          nullValue: null,
        },
        number_of_tyres_inspected: {
          value: "",
          valid: null,
          touched: false,
          message: null,
          nullValue: null,
        },
        average_nsd: {
          value: "",
          valid: null,
          touched: false,
          message: null,
          nullValue: null,
        },
        major_cause_of_removal: {
          value: "",
          valid: null,
          touched: false,
          message: null,
          nullValue: null,
        },
      },
      practices: ["good", "average", "poor"],
      image_err: false,
      isValidForm: false,
      isLoading: false,
      activityTypes: [],
      addEditActivityData: {},
      isEdit: false,
    };

    if (
      props.addEditActivityData &&
      Object.keys(props.addEditActivityData).length > 0
    ) {
      this.state.addEditActivityData = props.addEditActivityData;
      this.state.isEdit = true;
      this.state.controls.activity_type.value =
        props.addEditActivityData.activity_type;
      this.state.controls.activity_date.value = props.addEditActivityData
        .activity_date
        ? new Date(props.addEditActivityData.activity_date)
        : null;
      this.state.controls.number_of_tyres_inspected.value = props
        .addEditActivityData.number_of_tyres_inspected
        ? props.addEditActivityData.number_of_tyres_inspected
        : "";
      this.state.controls.number_of_driver_attended.value = props
        .addEditActivityData.number_of_driver_attended
        ? props.addEditActivityData.number_of_driver_attended
        : "";
      this.state.controls.number_of_vehicles_inspected.value = props
        .addEditActivityData.number_of_vehicles_inspected
        ? props.addEditActivityData.number_of_vehicles_inspected
        : "";
      this.state.controls.number_of_wheels_inspected.value = props
        .addEditActivityData.number_of_wheels_inspected
        ? props.addEditActivityData.number_of_wheels_inspected
        : "";
      this.state.controls.average_inflation_pressure_noted.value = props
        .addEditActivityData.average_inflation_pressure_noted
        ? props.addEditActivityData.average_inflation_pressure_noted
        : "";
      this.state.controls.select_alignment_practices.value = props
        .addEditActivityData.select_alignment_practices
        ? props.addEditActivityData.select_alignment_practices
        : "";
      this.state.controls.select_rotation_practices.value = props
        .addEditActivityData.select_rotation_practices
        ? props.addEditActivityData.select_rotation_practices
        : "";
      this.state.controls.front_axel_brand.value = props.addEditActivityData
        .front_axel_brand
        ? props.addEditActivityData.front_axel_brand
        : "";
      this.state.controls.front_axel_pattern.value = props.addEditActivityData
        .front_axel_pattern
        ? props.addEditActivityData.front_axel_pattern
        : "";
      this.state.controls.rear_axel_brand.value = props.addEditActivityData
        .rear_axel_brand
        ? props.addEditActivityData.rear_axel_brand
        : "";
      this.state.controls.major_observation.value = props.addEditActivityData
        .major_observation
        ? props.addEditActivityData.major_observation
        : "";
      this.state.controls.rear_axel_pattern.value = props.addEditActivityData
        .rear_axel_pattern
        ? props.addEditActivityData.rear_axel_pattern
        : "";
      this.state.controls.image_1.value = props.addEditActivityData.image_1
        ? props.addEditActivityData.image_1
        : "";
      this.state.controls.image_2.value = props.addEditActivityData.image_2
        ? props.addEditActivityData.image_2
        : "";
      this.state.controls.image_3.value = props.addEditActivityData.image_3
        ? props.addEditActivityData.image_3
        : "";
      this.state.controls.major_issue_before_dtp.value = props
        .addEditActivityData.major_issue_before_dtp
        ? props.addEditActivityData.major_issue_before_dtp
        : "";
      this.state.controls.solution_given.value = props.addEditActivityData
        .solution_given
        ? props.addEditActivityData.solution_given
        : "";
      this.state.controls.average_nsd.value = props.addEditActivityData
        .average_nsd
        ? props.addEditActivityData.average_nsd
        : "";
      this.state.controls.major_cause_of_removal.value = props
        .addEditActivityData.major_cause_of_removal
        ? props.addEditActivityData.major_cause_of_removal
        : "";
      this.state.controls.feedback_by_drivers.value = props.addEditActivityData
        .feedback_by_drivers
        ? props.addEditActivityData.feedback_by_drivers
        : "";
    }
  }

  componentWillMount() {
    document.body.style.overflow = "hidden";
    this.getBrand();
    this.getActivityList();
    this.getFleet();
    this.getPatternDid();
  }

  getPatternDid = async () => {
    if (this.state.controls.front_axel_pattern.value) {
      await this.getBrandPattern("front");
    }
    if (this.state.controls.rear_axel_pattern.value) {
      await this.getBrandPattern("rear");
    }
  };

  resetFilterType = (type) => {
    let { controls } = this.state;
    if (type !== 1 || type !== '1') {
      controls.number_of_vehicles_inspected.value = "";
      controls.number_of_wheels_inspected.value = "";
      controls.average_inflation_pressure_noted.value = "";
      controls.select_alignment_practices.value = "good";
      controls.select_rotation_practices.value = "good";
      controls.front_axel_brand.value = "";
      controls.front_axel_pattern.value = "";
      controls.rear_axel_brand.value = "";
      controls.rear_axel_pattern.value = "";
      controls.major_observation.value = "";
    } else if (type !== 2 || type !== '2' || type !== 4 || type !== '4') {
      controls.number_of_driver_attended.value = "";
      controls.major_issue_before_dtp.value = "";
      controls.solution_given.value = "";
      controls.feedback_by_drivers.value = "";
    } else if (type !== 3 || type !== '3') {
      controls.number_of_tyres_inspected.value = "";
      controls.average_nsd.value = "";
      controls.solution_given.value = "";
      controls.major_cause_of_removal.value = "";
    }
    this.setState({
      controls,
    });
  };

  handleInputChange = (e) => {
    const controlName = e.target.name;
    const controlValue = e.target.value;
    let { controls, rearBrandPattern, frontBrandPattern } = this.state;
    if (
      controlName === "number_of_driver_attended" ||
      controlName === "number_of_tyres_inspected" ||
      controlName === "number_of_vehicles_inspected" ||
      controlName === "number_of_wheels_inspected" ||
      controlName === "average_nsd" ||
      controlName === "average_inflation_pressure_noted"
    ) {
      if (!isNaN(e.target.value)) {
        controls[controlName].value = controlValue;
      }
    } else if (controlName === "front_axel_brand") {
      controls[controlName].value = controlValue;
      controls.front_axel_pattern.value = "";
      frontBrandPattern = [];
    } else if (controlName === "rear_axel_brand") {
      controls[controlName].value = controlValue;
      controls.rear_axel_pattern.value = "";
      rearBrandPattern = [];
    } else if (controlName === "activity_type") {
      this.resetFilterType(controlValue);
      controls[controlName].value = controlValue;
    } else {
      controls[controlName].value = controlValue;
    }
    controls[controlName].touched = true;
    this.setState({
      controls,
      rearBrandPattern,
      frontBrandPattern,
    });
    this.handleValidation(false);
    if (controlName === "front_axel_brand") {
      this.getBrandPattern("front");
    } else if (controlName === "rear_axel_brand") {
      this.getBrandPattern("rear");
    }
  };

  handleValidation = (isSubmit) => {
    let { controls, isValidForm, image_err } = this.state;
    let {
      activity_type,
      activity_date,
      fleet_id,
      number_of_tyres_inspected,
      number_of_driver_attended,
      number_of_vehicles_inspected,
    } = controls;
    if (activity_type.touched === true || isSubmit) {
      activity_type = Validation.notNullValidator(activity_type);
      activity_type.valid = !activity_type.nullValue;
      if (activity_type.valid === false) {
        activity_type.showErrorMsg = true;
      } else {
        activity_type.showErrorMsg = false;
      }
    }

    if (activity_date.touched === true || isSubmit) {
      activity_date = Validation.notNullValidator(activity_date);
      activity_date.valid = !activity_date.nullValue;
      if (activity_date.valid === false) {
        activity_date.showErrorMsg = true;
      } else {
        activity_date.showErrorMsg = false;
      }
    }

    if (fleet_id.touched === true || isSubmit) {
      fleet_id.valid = false;
      if (fleet_id.value && Object.keys(fleet_id.value).length > 0) {
        fleet_id.valid = true;
      }
      if (fleet_id.valid === false) {
        fleet_id.showErrorMsg = true;
      } else {
        fleet_id.showErrorMsg = false;
      }
    }

    if (
      (number_of_tyres_inspected.touched === true || isSubmit) &&
      (activity_type.value === "3" || activity_type.value === 3)
    ) {
      number_of_tyres_inspected = Validation.notNullValidator(
        number_of_tyres_inspected
      );
      number_of_tyres_inspected.valid = !number_of_tyres_inspected.nullValue;
      if (number_of_tyres_inspected.valid === false) {
        number_of_tyres_inspected.showErrorMsg = true;
      } else {
        number_of_tyres_inspected.showErrorMsg = false;
      }
    } else {
      number_of_tyres_inspected.valid = true;
    }

    if (
      (number_of_driver_attended.touched === true || isSubmit) &&
      (activity_type.value === 4 || activity_type.value === '4')
    ) {
      let image_total = 0;
      image_total = this.state.controls.image_1.value !== '' ? image_total + 1 : image_total;
      image_total = this.state.controls.image_2.value !== '' ? image_total + 1 : image_total;
      image_total = this.state.controls.image_3.value !== '' ? image_total + 1 : image_total;
      if (image_total < 2) {
        image_err = true;
      } else {
        image_err = false;
      }
      this.setState({ image_err });
    }

    if (
      (number_of_driver_attended.touched === true || isSubmit) &&
      (activity_type.value === "2" || activity_type.value === "4" || activity_type.value === 2 || activity_type.value === 4)
    ) {
      number_of_driver_attended = Validation.notNullValidator(
        number_of_driver_attended
      );
      number_of_driver_attended.valid = !number_of_driver_attended.nullValue;
      if (number_of_driver_attended.valid === false) {
        number_of_driver_attended.showErrorMsg = true;
      } else {
        number_of_driver_attended.showErrorMsg = false;
      }
    } else {
      number_of_driver_attended.valid = true;
    }

    if (
      (number_of_vehicles_inspected.touched === true || isSubmit) &&
      (activity_type.value === "1" || activity_type.value === 1)
    ) {
      number_of_vehicles_inspected = Validation.notNullValidator(
        number_of_vehicles_inspected
      );
      number_of_vehicles_inspected.valid = !number_of_vehicles_inspected.nullValue;
      if (number_of_vehicles_inspected.valid === false) {
        number_of_vehicles_inspected.showErrorMsg = true;
      } else {
        number_of_vehicles_inspected.showErrorMsg = false;
      }
    } else {
      number_of_vehicles_inspected.valid = true;
    }

    if (
      activity_type.valid &&
      activity_date.valid &&
      fleet_id.valid &&
      number_of_tyres_inspected.valid &&
      number_of_driver_attended.valid &&
      number_of_vehicles_inspected.valid &&
      (image_err === false || image_err === 'false')
    ) {
      isValidForm = true;
    } else {
      isValidForm = false;
    }

    this.setState({ isValidForm });
    return isValidForm;
  };

  getActivityList = (e) => {
    ActivityReportService.getActivityList()
      .then((response) => {
        this.setState({
          activityTypes: response.data.data,
        });
      })
      .catch((e) => {
        if (
          e.response &&
          e.response.data &&
          e.response.data.error &&
          e.response.data.error.length > 0
        ) {
          swal("", e.response.data.error[0].message, "error");
        }
      });
  };

  getFleet = async (e) => {
    let { customerData, controls, addEditActivityData } = this.state;
    try {
      const { data } = await SalesReportService.getFleets();
      if (data) {
        customerData = data.data;
      }

      if (addEditActivityData && addEditActivityData.fleet_id) {
        // let fleet_id = lodash.filter(
        //   customerData,
        //   function (o) {
        //     return addEditActivityData.fleet_id === o.uuid;
        //   }.bind(this)
        // );
        let fleet_id = lodash.filter(
          customerData,
          function (o) {
            return addEditActivityData.fleet_id === o.uuid;
          }
        );

        if (fleet_id && fleet_id.length > 0) {
          controls.fleet_id.value = fleet_id[0];
        }
      }
      this.setState({ customerData, controls });
    } catch (error) {
      console.log("error");
    }
  };

  updateSale = async (e) => {
    try {
      const isFormValid = this.handleValidation(true);
      if (!isFormValid) {
        return;
      }
      // const { sales } = this.props;
      const { salesData } = this.state;
      const obj = this.buildObj();
      obj.id = salesData.id;
      this.setState({ isLoading: true });
      // return;
      const { data } = await SalesReportService.editSales(obj);
      if (data) {
        ModalService.openAlert("Congratulations!", data.message, "success");
        this.resetControl();
        this.setState({ isLoading: false });
        this.props.openCloseSideBar(true);
      }
    } catch (e) {
      // let err = e.response && e.response.data && e.response.data.error[0] ? e.response.data.error[0] : null;
      // const message = err && err.message ? err.message : messages.COMMON.ERROR_MESSAGE;
      // this.setState({ isLoading: false });
      // ModalService.openAlert('Sorry!', message, 'error');
    }
  };

  componentWillUnmount() {
    document.body.style.overflow = "auto";
  }

  chooseFile = (imageNo) => {
    if (imageNo === "image1") {
      this.refImage1.click();
    } else if (imageNo === "image2") {
      this.refImage2.click();
    } else if (imageNo === "image3") {
      this.refImage3.click();
    }
  };

  uploadFileFormData = (file, type) => {
    let { controls } = this.state;
    let obj = {
      file: file,
    };
    this.setState({ isLoading: true });
    NewFleetService.uploadFleetDoc(obj, "activity_image")
      .then((res) => {
        if (res.data) {
          if (type === "image1") {
            controls.image_1.value = res.data.data.imageUrl;
          } else if (type === "image2") {
            controls.image_2.value = res.data.data.imageUrl;
          } else if (type === "image3") {
            controls.image_3.value = res.data.data.imageUrl;
          }
          this.setState({
            controls,
            isLoading: false,
          });
        }
      })
      .catch((e) => {
        if (type === "image1") {
          controls.image_1.value = "";
        } else if (type === "image2") {
          controls.image_2.value = "";
        } else if (type === "image3") {
          controls.image_3.value = "";
        }
        this.setState({
          controls,
          isLoading: false,
        });
      });
  };

  uploadFile = (event, type) => {
    // let { isLoading } = this.state;
    // isLoading = true;
    // this.setState({ isLoading });
    if (event.target.files[0]) {
      const file = event.target.files[0];
      //const file = new FormData();
      //file.append('file', event.target.files[0]);
      if (event.target.files[0].size > 5000000) {
        const { controls } = this.state;
        controls.document.value = "";
        event.target.value = null;
        ModalService.openAlert("", "Please upload valid file !", "error");
        return;
      }
      this.uploadFileFormData(file, type);
    }
  };

  getReqData = () => {
    let { controls } = this.state;
    let date = new Date(controls.activity_date.value);
    date.setHours(0);
    date.setMinutes(0);
    date.setSeconds(0);
    let reqData = {
      fleet_id: controls.fleet_id.value.uuid,
      activity_type: controls.activity_type.value,
      activity_date: date,
    };
    if (controls.number_of_vehicles_inspected.value) {
      reqData.number_of_vehicles_inspected =
        controls.number_of_vehicles_inspected.value;
    }
    if (controls.number_of_vehicles_inspected.value) {
      reqData.number_of_vehicles_inspected =
        controls.number_of_vehicles_inspected.value;
    }
    if (controls.number_of_wheels_inspected.value) {
      reqData.number_of_wheels_inspected =
        controls.number_of_wheels_inspected.value;
    }
    if (controls.average_inflation_pressure_noted.value) {
      reqData.average_inflation_pressure_noted =
        controls.average_inflation_pressure_noted.value;
    }
    if (controls.select_alignment_practices.value) {
      reqData.select_alignment_practices =
        controls.select_alignment_practices.value;
    }
    if (controls.select_rotation_practices.value) {
      reqData.select_rotation_practices =
        controls.select_rotation_practices.value;
    }

    reqData.front_axel_brand = controls.front_axel_brand.value;
    reqData.front_axel_pattern = controls.front_axel_pattern.value;
    reqData.rear_axel_brand = controls.rear_axel_brand.value;
    reqData.rear_axel_pattern = controls.rear_axel_pattern.value;

    if (controls.major_observation.value) {
      reqData.major_observation = controls.major_observation.value;
    }
    if (controls.number_of_driver_attended.value) {
      reqData.number_of_driver_attended =
        controls.number_of_driver_attended.value;
    }
    if (controls.major_issue_before_dtp.value) {
      reqData.major_issue_before_dtp = controls.major_issue_before_dtp.value;
    }
    if (controls.solution_given.value) {
      reqData.solution_given = controls.solution_given.value;
    }
    if (controls.feedback_by_drivers.value) {
      reqData.feedback_by_drivers = controls.feedback_by_drivers.value;
    }
    if (controls.number_of_tyres_inspected.value) {
      reqData.number_of_tyres_inspected =
        controls.number_of_tyres_inspected.value;
    }
    if (controls.average_nsd.value) {
      reqData.average_nsd = controls.average_nsd.value;
    }
    if (controls.major_cause_of_removal.value) {
      reqData.major_cause_of_removal = controls.major_cause_of_removal.value;
    }
    reqData.image_1 = controls.image_1.value ? controls.image_1.value : "";
    reqData.image_2 = controls.image_2.value ? controls.image_2.value : "";
    reqData.image_3 = controls.image_3.value ? controls.image_3.value : "";
    return reqData;
  };
  addEditActivity = () => {
    if (!this.handleValidation(true)) {
      return false;
    }
    let reqData = this.getReqData();
    if (this.props.addEditActivityData && this.props.addEditActivityData.uuid) {
      reqData.uuid = this.props.addEditActivityData.uuid;
    }
    this.setState({ isLoading: true });
    ActivityReportService.addEditActivity(reqData)
      .then((response) => {
        this.setState({ isLoading: false });
        swal({
          title: "",
          text: response.data.message,
          icon: "success",
          type: "success",
        }).then((value) => {
          this.props.openCloseSideBar(true);
        });
      })
      .catch((e) => {
        this.setState({ isLoading: false });
        if (
          e.response &&
          e.response.data &&
          e.response.data.error &&
          e.response.data.error.length > 0
        ) {
          ModalService.openAlert("", e.response.data.error[0].message, "error");
        }
      });
  };

  getBrandPattern = async (type) => {
    let { frontBrandPattern, rearBrandPattern, controls } = this.state;
    let reqData = {
      brand:
        type === "front"
          ? controls.front_axel_brand.value
          : controls.rear_axel_brand.value,
      is_all: true,
    };
    this.setState({ isLoading: true });
    await ActivityReportService.getPattern(reqData)
      .then((response) => {
        if (type === "front") {
          frontBrandPattern = response.data.data.pattern;
        } else {
          rearBrandPattern = response.data.data.pattern;
        }
        this.setState({
          isLoading: false,
          rearBrandPattern,
          frontBrandPattern,
        });
      })
      .catch((e) => {
        this.setState({ isLoading: false });
        if (
          e.response &&
          e.response.data &&
          e.response.data.error &&
          e.response.data.error.length > 0
        ) {
          ModalService.openAlert("", e.response.data.error[0].message, "error");
        }
      });
  };

  getBrand = () => {
    //this.setState({ isLoading: true });
    ActivityReportService.getBrand({ is_all: true })
      .then((response) => {
        let { brandData } = this.state;
        brandData = response.data.data.brand;
        this.setState({ brandData });
      })
      .catch((e) => {
        //this.setState({ isLoading: false });
        if (
          e.response &&
          e.response.data &&
          e.response.data.error &&
          e.response.data.error.length > 0
        ) {
          ModalService.openAlert("", e.response.data.error[0].message, "error");
        }
      });
  };

  closeSideBar = () => {
    this.props.openCloseSideBar(false);
  };

  removeImage = (imageNo) => {
    let { controls } = this.state;
    if (imageNo === "image1") {
      controls.image_1.value = "";
      this.refImage1.value = "";
    } else if (imageNo === "image2") {
      controls.image_2.value = "";
      this.refImage2.value = "";
    } else if (imageNo === "image3") {
      controls.image_3.value = "";
      this.refImage3.value = "";
    }
    this.setState({
      controls,
    });
  };

  render() {
    const { controls, customerData, image_err } = this.state;

    return (
      <div class="custom-drawer" id="AddEditActivity">
        {this.state.isLoading && (
          <CustomSpinner marginTop="50%"></CustomSpinner>
        )}
        <div style={{ marginTop: "60px" }}>
          <div className="drawer-header">
            <span className="drawer-title">
              {this.state.isEdit ? "Edit" : "Add"} An Activity
            </span>
            <img
              className="cursor-pointer"
              src="images/close.svg"
              alt="cancel"
              onClick={this.closeSideBar}
            />
          </div>
          <hr style={{ border: "solid 1px #ced4da" }} />
        </div>
        <div class="custom-drawer-content">
          <Row
            className="c-top-15"
            style={{ marginLeft: "0px", marginRight: "0px" }}
          >
            <Col xl="4" md="12" xs="12">
              <FormGroup>
                <Label for="gst">
                  Type of Activity<span className="required-field">*</span>
                </Label>
                <select
                  className="form-control"
                  name="activity_type"
                  value={controls.activity_type.value}
                  onChange={(e) => this.handleInputChange(e)}
                  disabled={this.state.isEdit}
                >
                  <option value="" selected="true" disabled>
                    Select Activity
                  </option>
                  {this.state.activityTypes &&
                    this.state.activityTypes.map((activity) => (
                      <option key={activity.id} value={activity.id}>
                        {activity.name}
                      </option>
                    ))}
                </select>
                {controls.activity_type.showErrorMsg && (
                  <div className="error">* Please select type of activity</div>
                )}
              </FormGroup>
            </Col>
            <Col xl="4" md="12" xs="12">
              <FormGroup>
                <Label for="gst">
                  Activity Date<span className="required-field">*</span>
                </Label>
                <Label
                  onClick={(e) =>
                    this.activityDate.state.open && e.preventDefault()
                  }
                  style={{ width: "100%" }}
                >
                  <InputGroup className="social-detail-date">
                    <DatePicker
                      className="form-control"
                      onChange={(e) =>
                        this.handleInputChange({
                          target: { name: "activity_date", value: e },
                        })
                      }
                      selected={controls.activity_date.value}
                      showMonthDropdown
                      ref={(r) => (this.activityDate = r)}
                      placeholderText="Select Date"
                      disabled={this.state.isEdit}
                      // shouldCloseOnSelect={true}
                      showYearDropdown
                      shouldCloseOnSelect
                      maxDate={new Date()}
                      dropdownMode="select"
                      style={{ zIndex: "auto" }}
                      dateFormat="dd/MM/yyyy"
                      popperPlacement="bottom"
                    // onFocus={this.props.activeFragment ? this.props.activeFragment.bind(this, 'social') : null}
                    />
                    <InputGroupAddon addonType="append">
                      <div
                        className="input-group-text"
                        style={{ zIndex: "auto !important", cursor: "pointer" }}
                      >
                        <FontAwesomeIcon
                          htmlFor="datepicker"
                          icon={faCalendarAlt}
                        />
                      </div>
                    </InputGroupAddon>
                  </InputGroup>
                </Label>
                {controls.activity_date.showErrorMsg && (
                  <div className="error mt-n2">
                    * Please select activity date
                  </div>
                )}
              </FormGroup>
            </Col>
            <Col xl="4" md="12" xs="12">
              <FormGroup>
                <Label for="gst">
                  Select Member<span className="required-field">*</span>
                </Label>
                <div className="d-flex-row select-member-typehead">
                  <Typeahead
                    id="customer"
                    disabled={this.state.isEdit}
                    filterBy={["business_name", "member_id"]}
                    labelKey={(option) =>
                      `${option.business_name} (${option.member_id})`
                    }
                    options={customerData}
                    placeholder="Type here"
                    onChange={(e) => {
                      this.handleInputChange({
                        target: { name: "fleet_id", value: e && e[0] },
                      });
                    }}
                    bsSize="small"
                    selected={
                      controls.fleet_id.value &&
                        Object.keys(controls.fleet_id.value).length > 0
                        ? [controls.fleet_id.value]
                        : []
                    }
                  />

                  <InputGroupAddon
                    addonType="append"
                    className="serach-icon"
                    style={{ marginTop: "0px" }}
                  >
                    <div
                      className="input-group-text"
                      style={{ paddingRight: "5px", marginTop: "-1px" }}
                    >
                      <FontAwesomeIcon htmlFor="datepicker" icon={faSearch} />
                    </div>
                  </InputGroupAddon>
                </div>
                {controls.fleet_id.showErrorMsg && (
                  <div className="error">* Please select member</div>
                )}
              </FormGroup>
            </Col>
          </Row>
          {(controls.activity_type.value === "1" || controls.activity_type.value === 1) && (
            <>
              <Row style={{ marginLeft: "0px", marginRight: "0px" }}>
                <Col xl="4" md="12" xs="12">
                  <FormGroup>
                    <Label for="gst">
                      No. of Vehicles Inspected
                      <span className="required-field">*</span>
                    </Label>
                    <Input
                      type="text"
                      name="number_of_vehicles_inspected"
                      value={controls.number_of_vehicles_inspected.value}
                      onChange={(e) => this.handleInputChange(e)}
                      placeholder="Type here"
                    />
                    {controls.number_of_vehicles_inspected.showErrorMsg && (
                      <div className="error">
                        * Please enter no. of vehicles inspected
                      </div>
                    )}
                  </FormGroup>
                </Col>
                <Col xl="4" md="12" xs="12">
                  <FormGroup>
                    <Label for="gst">No. of Wheels Inspected</Label>
                    <Input
                      type="text"
                      name="number_of_wheels_inspected"
                      value={controls.number_of_wheels_inspected.value}
                      onChange={(e) => this.handleInputChange(e)}
                      placeholder="Type here"
                    />
                  </FormGroup>
                </Col>
                <Col xl="4" md="12" xs="12">
                  <FormGroup>
                    <Label for="gst">Avg. Inflation Pressure Noted</Label>
                    <Input
                      type="text"
                      name="average_inflation_pressure_noted"
                      value={controls.average_inflation_pressure_noted.value}
                      onChange={(e) => this.handleInputChange(e)}
                      placeholder="Type here"
                    />
                  </FormGroup>
                </Col>
              </Row>
              <Row style={{ marginLeft: "0px", marginRight: "0px" }}>
                <Col xl="4" md="12" xs="12">
                  <FormGroup>
                    <Label for="gst">Select Alignment Practices</Label>
                    <select
                      className="form-control text-capitalize"
                      name="select_alignment_practices"
                      value={controls.select_alignment_practices.value}
                      onChange={(e) => this.handleInputChange(e)}
                    >
                      {this.state.practices.map((practice) => (
                        <option key={practice} value={practice}>
                          {practice}
                        </option>
                      ))}
                    </select>
                  </FormGroup>
                </Col>
                <Col xl="4" md="12" xs="12">
                  <FormGroup>
                    <Label for="gst">Select Rotation Practices</Label>
                    <select
                      className="form-control text-capitalize"
                      name="select_rotation_practices"
                      value={controls.select_rotation_practices.value}
                      onChange={(e) => this.handleInputChange(e)}
                    >
                      {this.state.practices.map((practice) => (
                        <option key={practice} value={practice}>
                          {practice}
                        </option>
                      ))}
                    </select>
                  </FormGroup>
                </Col>
              </Row>
              <Row style={{ marginLeft: "0px", marginRight: "0px" }}>
                <Col xl="4" md="12" xs="12">
                  <FormGroup>
                    <Label for="gst">Front Axel Brand</Label>
                    <select
                      className="form-control min-width-120px text-capitalize"
                      name="front_axel_brand"
                      value={controls.front_axel_brand.value}
                      onChange={(e) => this.handleInputChange(e)}
                    >
                      <option value="" selected>
                        Select
                      </option>
                      {(this.state.brandData || []).map((brand, j) => (
                        <option className="text-capitalize" value={brand.name}>
                          {brand.name}
                        </option>
                      ))}
                      <option value="other">Other</option>
                    </select>
                    {/* <Input
                      type="text"
                      name="front_axel_brand"
                      value={controls.front_axel_brand.value}
                      onChange={(e) => this.handleInputChange(e)}
                      placeholder="Type here" /> */}
                  </FormGroup>
                </Col>
                <Col xl="8" md="12" xs="12">
                  <FormGroup>
                    <Label for="gst">Front Axel Pattern</Label>
                    <select
                      className="form-control min-width-120px text-capitalize"
                      name="front_axel_pattern"
                      value={controls.front_axel_pattern.value}
                      onChange={(e) => this.handleInputChange(e)}
                    >
                      <option value="" selected disabled>
                        Select
                      </option>
                      {(this.state.frontBrandPattern || []).map((brand, j) => (
                        <option
                          className="text-capitalize"
                          value={brand.pattern}
                        >
                          {brand.pattern}
                        </option>
                      ))}
                      <option value="other">Other</option>
                    </select>
                    {/* <Input
                      type="text"
                      name="front_axel_pattern"
                      value={controls.front_axel_pattern.value}
                      onChange={(e) => this.handleInputChange(e)}
                      placeholder="Type here" /> */}
                  </FormGroup>
                </Col>
                <Col xl="4" md="12" xs="12">
                  <FormGroup>
                    <Label for="gst">Rear Axel Brand</Label>
                    <select
                      className="form-control min-width-120px text-capitalize"
                      name="rear_axel_brand"
                      value={controls.rear_axel_brand.value}
                      onChange={(e) => this.handleInputChange(e)}
                    >
                      <option value="" selected>
                        Select
                      </option>
                      {(this.state.brandData || []).map((brand, j) => (
                        <option className="text-capitalize" value={brand.name}>
                          {brand.name}
                        </option>
                      ))}
                      <option value="other">Other</option>
                    </select>
                    {/* <Input
                      type="text"
                      name="rear_axel_brand"
                      value={controls.rear_axel_brand.value}
                      onChange={(e) => this.handleInputChange(e)}
                      placeholder="Type here" /> */}
                  </FormGroup>
                </Col>
                <Col xl="8" md="12" xs="12">
                  <FormGroup>
                    <Label for="gst">Rear Axel Pattern</Label>
                    <select
                      className="form-control min-width-120px text-capitalize"
                      name="rear_axel_pattern"
                      value={controls.rear_axel_pattern.value}
                      onChange={(e) => this.handleInputChange(e)}
                    >
                      <option value="" selected disabled>
                        Select
                      </option>
                      {(this.state.rearBrandPattern || []).map((brand, j) => (
                        <option
                          className="text-capitalize"
                          value={brand.pattern}
                        >
                          {brand.pattern}
                        </option>
                      ))}
                      <option value="other">Other</option>
                    </select>
                    {/* <Input
                      type="text"
                      name="rear_axel_pattern"
                      value={controls.rear_axel_pattern.value}
                      onChange={(e) => this.handleInputChange(e)}
                      placeholder="Type here" /> */}
                  </FormGroup>
                </Col>
                <Col xl="12" md="12" xs="12">
                  <FormGroup>
                    <Label for="major_observation">Major Observations</Label>
                    <TextareaAutosize
                      name="major_observation"
                      style={{
                        maxHeight: 100,
                        fontSize: "14px",
                        minHeight: 60,
                      }}
                      value={controls.major_observation.value}
                      className="form-control"
                      onChange={(e) =>
                        this.handleInputChange({
                          target: {
                            name: "major_observation",
                            value: e.target.value,
                          },
                        })
                      }
                      placeholder="Type here"
                    />
                  </FormGroup>
                </Col>
              </Row>
            </>
          )}
          {(controls.activity_type.value === "2" || controls.activity_type.value === "4" || controls.activity_type.value === 2 || controls.activity_type.value === 4) && (
            <>
              <Row style={{ marginLeft: "0px", marginRight: "0px" }}>
                <Col xl="4" md="12" xs="12">
                  <FormGroup>
                    <Label for="number_of_driver_attended">
                      {/* No. of Drivers Attended */}
                      Number of Participants
                      <span className="required-field">*</span>
                    </Label>
                    <Input
                      type="text"
                      name="number_of_driver_attended"
                      value={controls.number_of_driver_attended.value}
                      onChange={(e) => this.handleInputChange(e)}
                      placeholder="Type here"
                    />
                    {controls.number_of_driver_attended.showErrorMsg && (
                      <div className="error">
                        * Please enter number of participants
                      </div>
                    )}
                  </FormGroup>
                </Col>
                <Col xl="12" md="12" xs="12">
                  <FormGroup>
                    <Label for="major_issue_before_dtp">
                      {/* Major issue before DTP */}
                      Major Point of Discussion
                    </Label>
                    <TextareaAutosize
                      name="major_issue_before_dtp"
                      style={{
                        maxHeight: 200,
                        fontSize: "14px",
                        minHeight: 60,
                      }}
                      className="form-control"
                      value={controls.major_issue_before_dtp.value}
                      onChange={(e) =>
                        this.handleInputChange({
                          target: {
                            name: "major_issue_before_dtp",
                            value: e.target.value,
                          },
                        })
                      }
                      placeholder="Type here"
                    />
                  </FormGroup>
                </Col>
                {((controls.activity_type.value === "2" || controls.activity_type.value === 2) && <Col xl="12" md="12" xs="12">
                  <FormGroup>
                    <Label for="solution_given">Solution Given</Label>
                    <TextareaAutosize
                      name="solution_given"
                      style={{
                        maxHeight: 100,
                        fontSize: "14px",
                        minHeight: 60,
                      }}
                      className="form-control"
                      value={controls.solution_given.value}
                      onChange={(e) =>
                        this.handleInputChange({
                          target: {
                            name: "solution_given",
                            value: e.target.value,
                          },
                        })
                      }
                      placeholder="Type here"
                    />
                  </FormGroup>
                </Col>)}
                <Col xl="12" md="12" xs="12">
                  <FormGroup>
                    <Label for="feedback_by_drivers">Feedback By Participants</Label>
                    <TextareaAutosize
                      name="feedback_by_drivers"
                      style={{
                        maxHeight: 100,
                        fontSize: "14px",
                        minHeight: 60,
                      }}
                      className="form-control"
                      value={controls.feedback_by_drivers.value}
                      onChange={(e) =>
                        this.handleInputChange({
                          target: {
                            name: "feedback_by_drivers",
                            value: e.target.value,
                          },
                        })
                      }
                      placeholder="Type here"
                    />
                  </FormGroup>
                </Col>
              </Row>
            </>
          )}
          {(controls.activity_type.value === "3" || controls.activity_type.value === 3) && (
            <>
              <Row style={{ marginLeft: "0px", marginRight: "0px" }}>
                <Col xl="4" md="12" xs="12">
                  <FormGroup>
                    <Label for="number_of_tyres_inspected">
                      No. of Tyres Inspected
                      <span className="required-field">*</span>
                    </Label>
                    <Input
                      type="text"
                      name="number_of_tyres_inspected"
                      value={controls.number_of_tyres_inspected.value}
                      onChange={(e) => this.handleInputChange(e)}
                      placeholder="Type here"
                    />
                    {controls.number_of_tyres_inspected.showErrorMsg && (
                      <div className="error">
                        * Please enter no. of tyres inspected
                      </div>
                    )}
                  </FormGroup>
                </Col>
                <Col xl="4" md="12" xs="12">
                  <FormGroup>
                    <Label for="gst">Average NSD</Label>
                    <Input
                      type="text"
                      name="average_nsd"
                      value={controls.average_nsd.value}
                      onChange={(e) => this.handleInputChange(e)}
                      placeholder="Type here"
                    />
                  </FormGroup>
                </Col>
                <Col xl="12" md="12" xs="12">
                  <FormGroup>
                    <Label for="major_cause_of_removal">
                      Major Cause of Removal
                    </Label>
                    <TextareaAutosize
                      name="major_cause_of_removal"
                      style={{
                        maxHeight: 100,
                        fontSize: "14px",
                        minHeight: 60,
                      }}
                      className="form-control"
                      value={controls.major_cause_of_removal.value}
                      onChange={(e) =>
                        this.handleInputChange({
                          target: {
                            name: "major_cause_of_removal",
                            value: e.target.value,
                          },
                        })
                      }
                      placeholder="Type here"
                    />
                  </FormGroup>
                </Col>
                <Col xl="12" md="12" xs="12">
                  <FormGroup>
                    <Label for="solution_given">Solution Given</Label>
                    <TextareaAutosize
                      name="solution_given"
                      style={{
                        maxHeight: 100,
                        fontSize: "14px",
                        minHeight: 60,
                      }}
                      className="form-control"
                      value={controls.solution_given.value}
                      onChange={(e) =>
                        this.handleInputChange({
                          target: {
                            name: "solution_given",
                            value: e.target.value,
                          },
                        })
                      }
                      placeholder="Type here"
                    />
                  </FormGroup>
                </Col>
              </Row>
            </>
          )}
          <Row style={{ marginLeft: "0px", marginRight: "0px" }}>
            <Col xl="12" md="12" xs="12">
              <span className="Upload-Photos-Lbl">Upload Photos</span>
            </Col>
            <Col xl="12" md="12" xs="12" className="mt-2">
              <Label>Upload Image1</Label>
              <Row>
                <Col xl="5" md="12" xs="12">
                  <div className="choose-file-wrapp">
                    <div
                      className="choose-file"
                      onClick={(e) => this.chooseFile("image1")}
                    >
                      <img
                        src="images/camera.svg"
                        className="choose-file-img"
                        alt="camera"
                      />
                      <span className="choose-file-lbl">Choose file</span>
                    </div>
                    <span className="choose-file-name">
                      {controls.image_1.value ? "Image1.jpg" : "-"}
                    </span>
                    {controls.image_1.value ? (
                      <img
                        className="cursor-pointer choose-file-cancel"
                        src="images/close.svg"
                        onClick={(e) => {
                          this.removeImage("image1");
                        }}
                        alt="close"
                      />
                    ) : (
                      ""
                    )}
                    <input
                      type="file"
                      style={{ display: "none" }}
                      onChange={(e) => this.uploadFile(e, "image1")}
                      ref={(r) => (this.refImage1 = r)}
                    />
                  </div>
                </Col>
                {controls.image_1.value && (
                  <Col xl="3" md="3" xs="3" style={{ marginTop: "-15px" }}>
                    <img src={controls.image_1.value} className="thumb-img" alt="" />
                  </Col>
                )}
              </Row>
            </Col>
            <Col xl="12" md="12" xs="12" className="mt-2">
              <Label>Upload Image2</Label>
              <Row>
                <Col xl="5" md="12" xs="12">
                  <div className="choose-file-wrapp">
                    <div
                      className="choose-file"
                      onClick={(e) => this.chooseFile("image2")}
                    >
                      <img
                        src="images/camera.svg"
                        className="choose-file-img"
                        alt=""
                      />
                      <span className="choose-file-lbl">Choose file</span>
                    </div>
                    <span className="choose-file-name">
                      {controls.image_2.value ? "Image2.jpg" : "-"}
                    </span>
                    {controls.image_2.value ? (
                      <img
                        className="cursor-pointer choose-file-cancel"
                        src="images/close.svg"
                        alt=""
                        onClick={(e) => {
                          this.removeImage("image2");
                        }}
                      />
                    ) : (
                      ""
                    )}
                    <input
                      type="file"
                      style={{ display: "none" }}
                      ref={(r) => (this.refImage2 = r)}
                      onChange={(e) => this.uploadFile(e, "image2")}
                    />
                  </div>
                </Col>
                {controls.image_2.value && (
                  <Col xl="3" md="3" xs="3" style={{ marginTop: "-15px" }}>
                    <img src={controls.image_2.value} alt="" className="thumb-img" />
                  </Col>
                )}
              </Row>
            </Col>
            <Col xl="12" md="12" xs="12" className="mt-2">
              <Label>Upload Image3</Label>
              <Row>
                <Col xl="5" md="12" xs="12">
                  <div className="choose-file-wrapp">
                    <div
                      className="choose-file"
                      onClick={(e) => this.chooseFile("image3")}
                    >
                      <img
                        src="images/camera.svg"
                        alt=""
                        className="choose-file-img"
                      />
                      <span className="choose-file-lbl">Choose file</span>
                    </div>
                    <span className="choose-file-name">
                      {controls.image_3.value ? "Image3.jpg" : "-"}
                    </span>
                    {controls.image_3.value ? (
                      <img
                        className="cursor-pointer choose-file-cancel"
                        src="images/close.svg"
                        alt=""
                        onClick={(e) => {
                          this.removeImage("image3");
                        }}
                        onChange={(e) => this.uploadFile(e, "image3")}
                      />
                    ) : (
                      ""
                    )}
                    <input
                      type="file"
                      style={{ display: "none" }}
                      ref={(r) => (this.refImage3 = r)}
                      onChange={(e) => this.uploadFile(e, "image3")}
                    />
                  </div>
                </Col>
                {controls.image_3.value && (
                  <Col xl="3" md="3" xs="3" style={{ marginTop: "-15px" }}>
                    <img src={controls.image_3.value} alt="" className="thumb-img" />
                  </Col>
                )}
              </Row>
              {image_err && (
                <div className="error">
                  * Please upload at least two image
                </div>
              )}
            </Col>
          </Row>
          <br /> <br />
        </div>
        <Row
          className="c-top-15 custom-drawer-footer"
          style={{ marginLeft: "0px", marginRight: "0px" }}
        >
          <Col>
            <Button
              //  disabled={!isValidForm}
              type="button"
              className="mb-1 mr-1 btn-pill action-button profile-save-button pull-right"
              color="warning"
              style={{ cursor: "pointer" }}
              onClick={() => this.addEditActivity()}
            >
              Save
            </Button>
          </Col>
        </Row>
      </div>
    );
  }
}

export default AddEditActivity;
